import AppBar from "@material-ui/core/AppBar";
import CssBaseline from "@material-ui/core/CssBaseline";
import Divider from "@material-ui/core/Divider";
import Drawer from "@material-ui/core/Drawer";
import IconButton from "@material-ui/core/IconButton";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import Toolbar from "@material-ui/core/Toolbar";
import Typography from "@material-ui/core/Typography";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import AccountCircle from "@material-ui/icons/AccountCircle";
import Assignment from "@material-ui/icons/Assignment";
import AssignmentInd from "@material-ui/icons/AssignmentInd";
import AssignmentTurnedIn from "@material-ui/icons/AssignmentTurnedIn";
import ChangeHistoryIcon from "@material-ui/icons/ChangeHistory";
import ChevronLeftIcon from "@material-ui/icons/ChevronLeft";
import ChevronRightIcon from "@material-ui/icons/ChevronRight";
import Computer from "@material-ui/icons/Computer";
import Create from "@material-ui/icons/Create";
import DateRange from "@material-ui/icons/DateRange";
import Dns from "@material-ui/icons/Dns";
import ExitToAppIcon from "@material-ui/icons/ExitToApp";
import FilterCenterFocus from "@material-ui/icons/FilterCenterFocus";
import FormatListNumberedRtl from "@material-ui/icons/FormatListNumberedRtl";
import HomeIcon from "@material-ui/icons/Home";
import Https from "@material-ui/icons/Https";
import Info from "@material-ui/icons/Info";
import LiveHelp from "@material-ui/icons/LiveHelp";
import LocalAtm from "@material-ui/icons/LocalAtm";
import MarkunreadMailbox from "@material-ui/icons/MarkunreadMailbox";
import MenuIcon from "@material-ui/icons/Menu";
import Money from "@material-ui/icons/Money";
import Person from "@material-ui/icons/Person";
import Receipt from "@material-ui/icons/Receipt";
import DisplaySettings from "@material-ui/icons/Settings";
import clsx from "clsx";
import React from "react";
import { Redirect, useHistory } from "react-router-dom";
import LogoText from "../../../assets/images/logo-main.png";
import ChangePassword from "../../../containers/ChangePassword/ChangePassword";
import Button from "../Button/Button";
import Modal from "../Modal/Modal";
import "./SidebarMenu.css";

const drawerWidth = 240;

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
  },
  appBar: {
    zIndex: theme.zIndex.drawer + 1,
    transition: theme.transitions.create(["width", "margin"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
  },
  appBarShift: {
    marginRight: drawerWidth,
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(["width", "margin"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  menuButton: {
    marginLeft: 36,
  },
  hide: {
    display: "none",
  },
  drawer: {
    width: drawerWidth,
    flexShrink: 0,
    whiteSpace: "nowrap",
  },
  drawerOpen: {
    width: drawerWidth,
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  drawerClose: {
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    overflowX: "hidden",
    width: theme.spacing(7) + 1,
    [theme.breakpoints.up("sm")]: {
      width: theme.spacing(9) + 1,
    },
  },
  toolbar: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
    padding: theme.spacing(0, 1),
    // necessary for content to be below app bar
    ...theme.mixins.toolbar,
  },
  content: {
    flexGrow: 1,
    padding: theme.spacing(3),
    minHeight: "100vh",
  },
}));

const MiniDrawer = (props) => {
  const classes = useStyles();
  const theme = useTheme();
  const [open, setOpen] = React.useState(
    window.innerWidth < 700 ? false : true
  );
  const [path, setPath] = React.useState("");
  const [redirect, setRedirect] = React.useState("");
  const [modalContent, setModalContent] = React.useState("");
  const [logout, setLogout] = React.useState(false);
  const [orderOpen, setOrderOpen] = React.useState(false);
  const [polygonOpen, setPolygonOpen] = React.useState(false);
  const [fireOpen, setFireOpen] = React.useState(false);
  const [redirectOrder, setRedirectOrder] = React.useState("");
  const [redirectBool, setRedirectBool] = React.useState(false);
  const [permission, setPermission] = React.useState(
    window.localStorage.getItem("permission")
  );
  let history = useHistory();
  const childRef = React.useRef();
  let menuTab = "";
  const historyPath = history.location.pathname;

  const handleDrawerOpen = () => {
    setOpen(true);
  };
  const handleDrawerClose = () => {
    setOpen(false);
  };
  const goToOrder = (event) => {
    setPath("orders-third");
    setRedirectBool(true);
    setRedirect(<Redirect to="orders-third" />);
    setTimeout(() => {
      setRedirectBool(false);
    }, 300);
  };
  const goToHome = (event) => {
    const path1 = "/";
    setRedirectBool(true);
    setRedirect(<Redirect to={path1} />);
    setTimeout(() => {
      setRedirectBool(false);
    }, 300);
  };
  const afterCloseModal = (event) => {};
  const closeModal = (event) => {
    childRef.current.closeModal();
  };
  const goChangePass = (event) => {
    setModalContent(<ChangePassword closeModal={closeModal} />);
    childRef.current.openModal();
  };

  const orderHandleClick = () => {
    setOrderOpen(!orderOpen);
  };

  const ordersPanel = (event) => {
    setRedirectBool(true);
    setRedirect(<Redirect to="orders" />);
    setTimeout(() => {
      setRedirectBool(false);
    }, 300);
  };

  const changeOrderIntervalPanel = (event) => {
    setRedirectBool(true);
    setRedirect(<Redirect to="change-order-interval" />);
    setTimeout(() => {
      setRedirectBool(false);
    }, 300);
  };

  const myOrdersPanel = (event) => {
    setRedirectBool(true);
    setRedirect(<Redirect to="my-orders" />);
    setTimeout(() => {
      setRedirectBool(false);
    }, 300);
  };
  const ordersForEvacuationPanel = (event) => {
    setRedirectBool(true);
    setRedirect(<Redirect to="evc-orders" />);
    setTimeout(() => {
      setRedirectBool(false);
    }, 300);
  };
  const registerOrderPanel = (event) => {
    setRedirectBool(true);
    setRedirect(<Redirect to="register-order" />);
    setTimeout(() => {
      setRedirectBool(false);
    }, 300);
  };
  const registerRentOrderPanel = (event) => {
    setRedirectBool(true);
    setRedirect(<Redirect to="register-rent-order" />);
    setTimeout(() => {
      setRedirectBool(false);
    }, 300);
  };
  const kioskOrderDetailsPanel = (event) => {
    setRedirectBool(true);
    setRedirect(<Redirect to="/kiosk-order-details" />);
    setTimeout(() => {
      setRedirectBool(false);
    }, 300);
  };
  const clientVideo = (event) => {
    setRedirectBool(true);
    setRedirect(<Redirect to="client-videos" />);
    setTimeout(() => {
      setRedirectBool(false);
    }, 300);
  };
  const unitFranchiseKiosks = (event) => {
    setRedirectBool(true);
    setRedirect(<Redirect to="unit-franchises" />);
    setTimeout(() => {
      setRedirectBool(false);
    }, 300);
  };
  const myFranchiseOrders = (event) => {
    setRedirectBool(true);
    setRedirect(<Redirect to="my-franchise-orders" />);
    setTimeout(() => {
      setRedirectBool(false);
    }, 300);
  };
  const eventPanel = (event) => {
    setRedirectBool(true);
    setRedirect(<Redirect to="event-list" />);
    setTimeout(() => {
      setRedirectBool(false);
    }, 300);
  };
  const eventListenerPanel = (event) => {
    setRedirectBool(true);
    setRedirect(<Redirect to="event-listeners" />);
    setTimeout(() => {
      setRedirectBool(false);
    }, 300);
  };
  const clientLogs = (event) => {
    setRedirectBool(true);
    setRedirect(<Redirect to="logs" />);
    setTimeout(() => {
      setRedirectBool(false);
    }, 300);
  };
  const lockerTypesPanel = (event) => {
    setRedirectBool(true);
    setRedirect(<Redirect to="locker-types" />);
    setTimeout(() => {
      setRedirectBool(false);
    }, 300);
  };
  const bunchesPanel = (event) => {
    setRedirectBool(true);
    setRedirect(<Redirect to="bunches" />);
    setTimeout(() => {
      setRedirectBool(false);
    }, 300);
  };
  const kioskTypesPanel = (event) => {
    setRedirectBool(true);
    setRedirect(<Redirect to="kiosk-types" />);
    setTimeout(() => {
      setRedirectBool(false);
    }, 300);
  };
  const kiosksPanel = (event) => {
    setRedirectBool(true);
    setRedirect(<Redirect to="kiosks" />);
    setTimeout(() => {
      setRedirectBool(false);
    }, 300);
  };
  const generation2Panel = (event) => {
    setRedirectBool(true);
    setRedirect(<Redirect to="gnr2" />);
    setTimeout(() => {
      setRedirectBool(false);
    }, 300);
  };
  const shiftKiosksPanel = (event) => {
    setRedirectBool(true);
    setRedirect(<Redirect to="/shift-kiosk" />);
    setTimeout(() => {
      setRedirectBool(false);
    }, 300);
  };
  const kioskDetailsPanel = (event) => {
    setRedirectBool(true);
    setRedirect(<Redirect to="kiosks-details" />);
    setTimeout(() => {
      setRedirectBool(false);
    }, 300);
  };
  const zonesPanel = (event) => {
    setRedirectBool(true);
    setRedirect(<Redirect to="zones" />);
    setTimeout(() => {
      setRedirectBool(false);
    }, 300);
  };
  const calendarZonesPanel = (event) => {
    setRedirectBool(true);
    setRedirect(<Redirect to="calendar-zones" />);
    setTimeout(() => {
      setRedirectBool(false);
    }, 300);
  };
  const tariffsPanel = (event) => {
    setRedirectBool(true);
    setRedirect(<Redirect to="tariffs" />);
    setTimeout(() => {
      setRedirectBool(false);
    }, 300);
  };
  const tariffValuesPanel = (event) => {
    setRedirectBool(true);
    setRedirect(<Redirect to="tariff-values" />);
    setTimeout(() => {
      setRedirectBool(false);
    }, 300);
  };
  const tariffCancelsPanel = (event) => {
    setRedirectBool(true);
    setRedirect(<Redirect to="tariff-cancels" />);
    setTimeout(() => {
      setRedirectBool(false);
    }, 300);
  };
  const systemPoliciesPanel = (event) => {
    setRedirectBool(true);
    setRedirect(<Redirect to="system-policies" />);
    setTimeout(() => {
      setRedirectBool(false);
    }, 300);
  };
  const elockChangesPanel = (event) => {
    setRedirectBool(true);
    setRedirect(<Redirect to="elock-changes" />);
    setTimeout(() => {
      setRedirectBool(false);
    }, 300);
  };
  const contentPanel = (event) => {
    setRedirectBool(true);
    setRedirect(<Redirect to="contents" />);
    setTimeout(() => {
      setRedirectBool(false);
    }, 300);
  };
  const userManagementPanel = (event) => {
    setRedirectBool(true);
    setRedirect(<Redirect to="users" />);
    setTimeout(() => {
      setRedirectBool(false);
    }, 300);
  };

  const unitManagementPanel = (event) => {
    setRedirectBool(true);
    setRedirect(<Redirect to="units" />);
    setTimeout(() => {
      setRedirectBool(false);
    }, 300);
  };

  const unitPickupAddressManagementPanel = (event) => {
    setRedirectBool(true);
    setRedirect(<Redirect to="unit-pickup-addresses" />);
    setTimeout(() => {
      setRedirectBool(false);
    }, 300);
  };

  // const kioskUnitsPanel = (event) => {
  //     setRedirectBool(true)
  //     setRedirect(<Redirect to='kiosk-units' />)
  //     setTimeout(() => {
  //         setRedirectBool(false)
  //     }, 300)
  // }

  const unitBoxesPanel = (event) => {
    setRedirectBool(true);
    setRedirect(<Redirect to="unit-kiosks" />);
    setTimeout(() => {
      setRedirectBool(false);
    }, 300);
  };

  const reportManagementPanel = (event) => {
    setRedirectBool(true);
    setRedirect(<Redirect to="reports" />);
    setTimeout(() => {
      setRedirectBool(false);
    }, 300);
  };

  const allReportManagementPanel = (event) => {
    setRedirectBool(true);
    setRedirect(<Redirect to="all-reports" />);
    setTimeout(() => {
      setRedirectBool(false);
    }, 300);
  };

  const complementaryReportManagementPanel = (event) => {
    setRedirectBool(true);
    setRedirect(<Redirect to="clmnt-reports" />);
    setTimeout(() => {
      setRedirectBool(false);
    }, 300);
  };

  const invoiceManagementPanel = (event) => {
    setRedirectBool(true);
    setRedirect(<Redirect to="invoices" />);
    setTimeout(() => {
      setRedirectBool(false);
    }, 300);
  };

  const myProfile = (event) => {
    setRedirectBool(true);
    setRedirect(<Redirect to="my-profile" />);
    setTimeout(() => {
      setRedirectBool(false);
    }, 300);
  };

  const aboutUsPanel = (event) => {
    setRedirectBool(true);
    setRedirect(<Redirect to="about-us" />);
    setTimeout(() => {
      setRedirectBool(false);
    }, 300);
  };

  const faqContentPanel = (event) => {
    setRedirectBool(true);
    setRedirect(<Redirect to="faq-content" />);
    setTimeout(() => {
      setRedirectBool(false);
    }, 300);
  };

  const doLogout = (event) => {
    window.localStorage.setItem("token", "");
    window.localStorage.setItem("permission", "");
    window.localStorage.setItem("userId", "");
    window.localStorage.setItem("expiration", "");
    window.localStorage.setItem("token", "");
    window.localStorage.setItem("username", "");
    window.localStorage.setItem("password", "");
    setLogout(true);
  };
  const afterLogout = logout === true ? <Redirect to="/" /> : "";
  return (
    <div className={classes.root}>
      {afterLogout}
      {redirectBool ? redirect : ""}
      <CssBaseline />
      <AppBar
        position="fixed"
        className={clsx(classes.appBar, {
          [classes.appBarShift]: open,
        })}
      >
        <Toolbar>
          <IconButton
            color="inherit"
            aria-label="open drawer"
            onClick={handleDrawerOpen}
            edge="start"
            className={[
              clsx(classes.menuButton, {
                [classes.hide]: open,
              }),
              "side-open-icon",
            ].join(" ")}
          >
            <MenuIcon />
          </IconButton>
          <div className="row w-100">
            <div className="col-7 side-user-info">
              <Typography className="side-user" variant="h6" noWrap>
                <AccountCircle onClick={myProfile} className="user-icon" />
                <span className="sidebar-icon desktop-only">
                  {window.localStorage.getItem("username")}
                </span>
              </Typography>
            </div>
            <div className="col-3 text-left mt-1 desktop-only">
              <div className="row justify-content-center mt-4 desktop-only">
                <div className="col-5 p-0 text-left">
                  <Button btnType="toolbar" clicked={aboutUsPanel}>
                    <Info
                      className={
                        history.location.pathname == "/orders"
                          ? "menu-selected-icon"
                          : "sidebar-icon"
                      }
                    />
                    &nbsp;&nbsp;درباره ما
                  </Button>
                </div>
                <div className="col-1">
                  <span className="toolbar-line"></span>
                </div>
                <div className="col-5 p-0">
                  <Button btnType="toolbar" clicked={faqContentPanel}>
                    <LiveHelp
                      className={
                        history.location.pathname == "/orders"
                          ? "menu-selected-icon"
                          : "sidebar-icon"
                      }
                    />
                    &nbsp;&nbsp;سوالات متداول
                  </Button>
                </div>
              </div>
            </div>
            <div className="col-2 text-left mt-1 desktop-only">
              <img className="sidebar-logo" src={LogoText} />
            </div>
          </div>
        </Toolbar>
      </AppBar>
      <Drawer
        variant="permanent"
        className={clsx(classes.drawer, {
          [classes.drawerOpen]: open,
          [classes.drawerClose]: !open,
        })}
        classes={{
          paper: clsx({
            [classes.drawerOpen]: open,
            [classes.drawerClose]: !open,
          }),
        }}
      >
        <div className={classes.toolbar}>
          <IconButton onClick={handleDrawerClose}>
            {theme.direction === "rtl" ? (
              <ChevronRightIcon />
            ) : (
              <ChevronLeftIcon />
            )}
          </IconButton>
        </div>
        <Divider />
        <List>
          <ListItem
            className={history.location.pathname == "/" ? "menu-selected" : ""}
            button
            onClick={goToHome}
          >
            <ListItemIcon>
              <HomeIcon
                className={
                  history.location.pathname == "/"
                    ? "menu-selected-icon"
                    : "sidebar-icon"
                }
              />
            </ListItemIcon>
            <ListItemText primary="خانه" />
          </ListItem>
          {permission != null &&
          (permission.includes("ORDER_READ") ||
            permission.includes("RENT_READ")) ? (
            <ListItem
              className={
                history.location.pathname == "/orders" ? "menu-selected" : ""
              }
              button
              onClick={ordersPanel}
            >
              <ListItemIcon>
                <Assignment
                  className={
                    history.location.pathname == "/orders"
                      ? "menu-selected-icon"
                      : "sidebar-icon"
                  }
                />
              </ListItemIcon>
              <ListItemText primary="مدیریت سفارشات" />
            </ListItem>
          ) : (
            ""
          )}
          {permission != null && permission.includes("CHANGE_WRITE") ? (
            <ListItem
              className={
                history.location.pathname == "/change-order-interval"
                  ? "menu-selected"
                  : ""
              }
              button
              onClick={changeOrderIntervalPanel}
            >
              <ListItemIcon>
                <DateRange
                  className={
                    history.location.pathname == "/change-order-interval"
                      ? "menu-selected-icon"
                      : "sidebar-icon"
                  }
                />
              </ListItemIcon>
              <ListItemText primary="تغییر بازه سفارش" />
            </ListItem>
          ) : (
            ""
          )}
          <ListItem
            className={
              history.location.pathname == "/my-orders" ? "menu-selected" : ""
            }
            button
            onClick={myOrdersPanel}
          >
            <ListItemIcon>
              <Assignment
                className={
                  history.location.pathname == "/my-orders"
                    ? "menu-selected-icon"
                    : "sidebar-icon"
                }
              />
            </ListItemIcon>
            <ListItemText primary="سفارشات من" />
          </ListItem>
          {permission != null &&
          (permission.includes("ADMIN_READ") ||
            permission.includes("ADMIN_WRITE")) ? (
            <ListItem
              className={
                history.location.pathname == "/evc-orders"
                  ? "menu-selected"
                  : ""
              }
              button
              onClick={ordersForEvacuationPanel}
            >
              <ListItemIcon>
                <Assignment
                  className={
                    history.location.pathname == "/evc-orders"
                      ? "menu-selected-icon"
                      : "sidebar-icon"
                  }
                />
              </ListItemIcon>
              <ListItemText primary="سفارشات تخلیه نشده" />
            </ListItem>
          ) : (
            ""
          )}
          {permission != null && permission.includes("ORDER_WRITE") ? (
            <ListItem
              className={
                history.location.pathname == "/register-order"
                  ? "menu-selected"
                  : ""
              }
              button
              onClick={registerOrderPanel}
            >
              <ListItemIcon>
                <Create
                  className={
                    history.location.pathname == "/register-order"
                      ? "menu-selected-icon"
                      : "sidebar-icon"
                  }
                />
              </ListItemIcon>
              <ListItemText primary="ثبت سفارش" />
            </ListItem>
          ) : (
            ""
          )}
          {permission != null && permission.includes("RENT_WRITE") ? (
            <ListItem
              className={
                history.location.pathname == "/register-rent-order"
                  ? "menu-selected"
                  : ""
              }
              button
              onClick={registerRentOrderPanel}
            >
              <ListItemIcon>
                <Create
                  className={
                    history.location.pathname == "/register-rent-order"
                      ? "menu-selected-icon"
                      : "sidebar-icon"
                  }
                />
              </ListItemIcon>
              <ListItemText primary="ثبت سفارش اجاره ای" />
            </ListItem>
          ) : (
            ""
          )}
          {permission != null && permission.includes("KIOSK_READ") ? (
            <ListItem
              className={
                history.location.pathname == "/kiosk-order-details"
                  ? "menu-selected"
                  : ""
              }
              button
              onClick={kioskOrderDetailsPanel}
            >
              <ListItemIcon>
                <Computer
                  className={
                    history.location.pathname == "/kiosk-order-details"
                      ? "menu-selected-icon"
                      : "sidebar-icon"
                  }
                />
              </ListItemIcon>
              <ListItemText primary="پایش سفارشات لاکر" />
            </ListItem>
          ) : (
            ""
          )}
          {permission != null && permission.includes("UNIT_READ") ? (
            <ListItem
              className={
                history.location.pathname == "/unit-franchises"
                  ? "menu-selected"
                  : ""
              }
              button
              onClick={unitFranchiseKiosks}
            >
              <ListItemIcon>
                <Create
                  className={
                    history.location.pathname == "/unit-franchises"
                      ? "menu-selected-icon"
                      : "sidebar-icon"
                  }
                />
              </ListItemIcon>
              <ListItemText primary="مدیریت فرانچایز" />
            </ListItem>
          ) : (
            ""
          )}
          {permission != null && permission.includes("FRANCHISE_READ") ? (
            <ListItem
              className={
                history.location.pathname == "/my-franchise-orders"
                  ? "menu-selected"
                  : ""
              }
              button
              onClick={myFranchiseOrders}
            >
              <ListItemIcon>
                <Create
                  className={
                    history.location.pathname == "/my-franchise-orders"
                      ? "menu-selected-icon"
                      : "sidebar-icon"
                  }
                />
              </ListItemIcon>
              <ListItemText primary="سفارشات فرانچایزی من" />
            </ListItem>
          ) : (
            ""
          )}
          {permission != null && permission.includes("EVENT_READ") ? (
            <ListItem
              className={
                history.location.pathname == "/event-list"
                  ? "menu-selected"
                  : ""
              }
              button
              onClick={eventPanel}
            >
              <ListItemIcon>
                <Create
                  className={
                    history.location.pathname == "/event-list"
                      ? "menu-selected-icon"
                      : "sidebar-icon"
                  }
                />
              </ListItemIcon>
              <ListItemText primary="مدیریت نوع رویدادها" />
            </ListItem>
          ) : (
            ""
          )}
          {permission != null && permission.includes("EVENT_READ") ? (
            <ListItem
              className={
                history.location.pathname == "/event-listeners"
                  ? "menu-selected"
                  : ""
              }
              button
              onClick={eventListenerPanel}
            >
              <ListItemIcon>
                <Create
                  className={
                    history.location.pathname == "/event-listeners"
                      ? "menu-selected-icon"
                      : "sidebar-icon"
                  }
                />
              </ListItemIcon>
              <ListItemText primary="مدیریت رویدادها" />
            </ListItem>
          ) : (
            ""
          )}
          {permission != null && permission.includes("CONTENT_READ") ? (
            <ListItem
              className={
                history.location.pathname == "/client-videos"
                  ? "menu-selected"
                  : ""
              }
              button
              onClick={clientVideo}
            >
              <ListItemIcon>
                <Create
                  className={
                    history.location.pathname == "/client-videos"
                      ? "menu-selected-icon"
                      : "sidebar-icon"
                  }
                />
              </ListItemIcon>
              <ListItemText primary="مدیریت ویدئوها" />
            </ListItem>
          ) : (
            ""
          )}
          {permission != null && permission.includes("LOG_READ") ? (
            <ListItem
              className={
                history.location.pathname == "/logs" ? "menu-selected" : ""
              }
              button
              onClick={clientLogs}
            >
              <ListItemIcon>
                <Create
                  className={
                    history.location.pathname == "/client-videos"
                      ? "menu-selected-icon"
                      : "sidebar-icon"
                  }
                />
              </ListItemIcon>
              <ListItemText primary="لاگهای درخواست کوریر" />
            </ListItem>
          ) : (
            ""
          )}
          {permission != null && permission.includes("LOCKER_TYPE_READ") ? (
            <ListItem
              className={
                history.location.pathname == "/locker-types"
                  ? "menu-selected"
                  : ""
              }
              button
              onClick={lockerTypesPanel}
            >
              <ListItemIcon>
                <Https
                  className={
                    history.location.pathname == "/locker-types"
                      ? "menu-selected-icon"
                      : "sidebar-icon"
                  }
                />
              </ListItemIcon>
              <ListItemText primary="مدیریت نوع باکس ها" />
            </ListItem>
          ) : (
            ""
          )}
          {permission != null && permission.includes("BUNCH_READ") ? (
            <ListItem
              className={
                history.location.pathname == "/bunches" ? "menu-selected" : ""
              }
              button
              onClick={bunchesPanel}
            >
              <ListItemIcon>
                <Https
                  className={
                    history.location.pathname == "/bunches"
                      ? "menu-selected-icon"
                      : "sidebar-icon"
                  }
                />
              </ListItemIcon>
              <ListItemText primary="مدیریت خوشه ها" />
            </ListItem>
          ) : (
            ""
          )}
          {permission != null && permission.includes("KIOSK_TYPE_READ") ? (
            <ListItem
              className={
                history.location.pathname == "/kiosk-types"
                  ? "menu-selected"
                  : ""
              }
              button
              onClick={kioskTypesPanel}
            >
              <ListItemIcon>
                <MarkunreadMailbox
                  className={
                    history.location.pathname == "/kiosk-types"
                      ? "menu-selected-icon"
                      : "sidebar-icon"
                  }
                />
              </ListItemIcon>
              <ListItemText primary="مدیریت نوع لاکر ها" />
            </ListItem>
          ) : (
            ""
          )}
          {permission != null && permission.includes("KIOSK_READ") ? (
            <ListItem
              className={
                history.location.pathname == "/kiosks" ? "menu-selected" : ""
              }
              button
              onClick={kiosksPanel}
            >
              <ListItemIcon>
                <Dns
                  className={
                    history.location.pathname == "/kiosks"
                      ? "menu-selected-icon"
                      : "sidebar-icon"
                  }
                />
              </ListItemIcon>
              <ListItemText primary="مدیریت لاکر ها" />
            </ListItem>
          ) : (
            ""
          )}
          {permission != null && permission.includes("KIOSK_READ") ? (
            <ListItem
              className={
                history.location.pathname == "/gnr2" ? "menu-selected" : ""
              }
              button
              onClick={generation2Panel}
            >
              <ListItemIcon>
                <Dns
                  className={
                    history.location.pathname == "/gnr2"
                      ? "menu-selected-icon"
                      : "sidebar-icon"
                  }
                />
              </ListItemIcon>
              <ListItemText primary="باز کردن درب لاکر نسل ۲" />
            </ListItem>
          ) : (
            ""
          )}
          {permission != null && permission.includes("KIOSK_READ") ? (
            <ListItem
              className={
                history.location.pathname == "/shift-kiosk"
                  ? "menu-selected"
                  : ""
              }
              button
              onClick={shiftKiosksPanel}
            >
              <ListItemIcon>
                <Dns
                  className={
                    history.location.pathname == "/shift-kiosk"
                      ? "menu-selected-icon"
                      : "sidebar-icon"
                  }
                />
              </ListItemIcon>
              <ListItemText primary="مدیریت شیفت‌های لاکر‌ها" />
            </ListItem>
          ) : (
            ""
          )}
          {permission != null && permission.includes("KIOSK_READ") ? (
            <ListItem
              className={
                history.location.pathname == "/kiosks-details"
                  ? "menu-selected"
                  : ""
              }
              button
              onClick={kioskDetailsPanel}
            >
              <ListItemIcon>
                <Computer
                  className={
                    history.location.pathname == "/kiosks-details"
                      ? "menu-selected-icon"
                      : "sidebar-icon"
                  }
                />
              </ListItemIcon>
              <ListItemText primary="پایش لاکر ها" />
            </ListItem>
          ) : (
            ""
          )}
          {permission != null && permission.includes("ZONE_READ") ? (
            <ListItem
              className={
                history.location.pathname == "/zones" ? "menu-selected" : ""
              }
              button
              onClick={zonesPanel}
            >
              <ListItemIcon>
                <FilterCenterFocus
                  className={
                    history.location.pathname == "/zones"
                      ? "menu-selected-icon"
                      : "sidebar-icon"
                  }
                />
              </ListItemIcon>
              <ListItemText primary="مدیریت zone ها" />
            </ListItem>
          ) : (
            ""
          )}
          {permission != null && permission.includes("ZONE_READ") ? (
            <ListItem
              className={
                history.location.pathname == "/calendar-zones"
                  ? "menu-selected"
                  : ""
              }
              button
              onClick={calendarZonesPanel}
            >
              <ListItemIcon>
                <DateRange
                  className={
                    history.location.pathname == "/calendar-zones"
                      ? "menu-selected-icon"
                      : "sidebar-icon"
                  }
                />
              </ListItemIcon>
              <ListItemText primary="zone تاریخی" />
            </ListItem>
          ) : (
            ""
          )}
          {permission != null && permission.includes("TARIFF_READ") ? (
            <ListItem
              className={
                history.location.pathname == "/tariffs" ? "menu-selected" : ""
              }
              button
              onClick={tariffsPanel}
            >
              <ListItemIcon>
                <LocalAtm
                  className={
                    history.location.pathname == "/tariffs"
                      ? "menu-selected-icon"
                      : "sidebar-icon"
                  }
                />
              </ListItemIcon>
              <ListItemText primary="مدیریت تعرفه" />
            </ListItem>
          ) : (
            ""
          )}
          {permission != null && permission.includes("TARIFF_VALUE_READ") ? (
            <ListItem
              className={
                history.location.pathname == "/tariff-values"
                  ? "menu-selected"
                  : ""
              }
              button
              onClick={tariffValuesPanel}
            >
              <ListItemIcon>
                <Money
                  className={
                    history.location.pathname == "/tariff-values"
                      ? "menu-selected-icon"
                      : "sidebar-icon"
                  }
                />
              </ListItemIcon>
              <ListItemText primary="مدیریت مقادیر تعرفه" />
            </ListItem>
          ) : (
            ""
          )}
          {permission != null && permission.includes("TARIFF_VALUE_READ") ? (
            <ListItem
              className={
                history.location.pathname == "/tariff-cancels"
                  ? "menu-selected"
                  : ""
              }
              button
              onClick={tariffCancelsPanel}
            >
              <ListItemIcon>
                <Money
                  className={
                    history.location.pathname == "/tariff-cancels"
                      ? "menu-selected-icon"
                      : "sidebar-icon"
                  }
                />
              </ListItemIcon>
              <ListItemText primary="مدیریت کنسلی" />
            </ListItem>
          ) : (
            ""
          )}
          {permission != null && permission.includes("SYSTEM_POLICY_READ") ? (
            <ListItem
              className={
                history.location.pathname == "/system-policies"
                  ? "menu-selected"
                  : ""
              }
              button
              onClick={systemPoliciesPanel}
            >
              <ListItemIcon>
                <DisplaySettings
                  className={
                    history.location.pathname == "/system-policies"
                      ? "menu-selected-icon"
                      : "sidebar-icon"
                  }
                />
              </ListItemIcon>
              <ListItemText primary="مدیریت کنترل های سیستمی" />
            </ListItem>
          ) : (
            ""
          )}
          {permission != null && permission.includes("CONTENT_READ") ? (
            <ListItem
              className={
                history.location.pathname == "/elock-changes"
                  ? "menu-selected"
                  : ""
              }
              button
              onClick={elockChangesPanel}
            >
              <ListItemIcon>
                <AssignmentTurnedIn
                  className={
                    history.location.pathname == "/elock-changes"
                      ? "menu-selected-icon"
                      : "sidebar-icon"
                  }
                />
              </ListItemIcon>
              <ListItemText primary="مدیریت تغییرات سیستم" />
            </ListItem>
          ) : (
            ""
          )}
          {permission != null && permission.includes("CONTENT_READ") ? (
            <ListItem
              className={
                history.location.pathname == "/contents" ? "menu-selected" : ""
              }
              button
              onClick={contentPanel}
            >
              <ListItemIcon>
                <AssignmentTurnedIn
                  className={
                    history.location.pathname == "/contents"
                      ? "menu-selected-icon"
                      : "sidebar-icon"
                  }
                />
              </ListItemIcon>
              <ListItemText primary="مدیریت محتوا" />
            </ListItem>
          ) : (
            ""
          )}
          {permission != null && permission.includes("USER_READ") ? (
            <ListItem
              className={
                history.location.pathname == "/users" ? "menu-selected" : ""
              }
              button
              onClick={userManagementPanel}
            >
              <ListItemIcon>
                <AssignmentInd
                  className={
                    history.location.pathname == "/users"
                      ? "menu-selected-icon"
                      : "sidebar-icon"
                  }
                />
              </ListItemIcon>
              <ListItemText primary="مدیریت کاربران" />
            </ListItem>
          ) : (
            ""
          )}
          {permission != null && permission.includes("UNIT_READ") ? (
            <ListItem
              className={
                history.location.pathname == "/units" ? "menu-selected" : ""
              }
              button
              onClick={unitManagementPanel}
            >
              <ListItemIcon>
                <Person
                  className={
                    history.location.pathname == "/units"
                      ? "menu-selected-icon"
                      : "sidebar-icon"
                  }
                />
              </ListItemIcon>
              <ListItemText primary="مدیریت حساب ها" />
            </ListItem>
          ) : (
            ""
          )}
          {permission != null && permission.includes("UNIT_READ") ? (
            <ListItem
              className={
                history.location.pathname == "/unit-pickup-addresses"
                  ? "menu-selected"
                  : ""
              }
              button
              onClick={unitPickupAddressManagementPanel}
            >
              <ListItemIcon>
                <Person
                  className={
                    history.location.pathname == "/unit-pickup-addresses"
                      ? "menu-selected-icon"
                      : "sidebar-icon"
                  }
                />
              </ListItemIcon>
              <ListItemText primary="آدرس های جمع آوری/ تخلیه" />
            </ListItem>
          ) : (
            ""
          )}
          {/* {permission != null && permission.includes('UNIT_READ') ?
                        <ListItem className={history.location.pathname == "/kiosk-units" ? "menu-selected" : ""} button onClick={kioskUnitsPanel}>
                            <ListItemIcon><Dns className={history.location.pathname == "/kiosk-units" ? "menu-selected-icon" : "sidebar-icon"} /></ListItemIcon>
                            <ListItemText primary="مدیریت محدودیت لاکرها" />
                        </ListItem>
                        : ''} */}
          {permission != null && permission.includes("UNIT_READ") ? (
            <ListItem
              className={
                history.location.pathname == "/unit-kiosks"
                  ? "menu-selected"
                  : ""
              }
              button
              onClick={unitBoxesPanel}
            >
              <ListItemIcon>
                <Dns
                  className={
                    history.location.pathname == "/unit-kiosks"
                      ? "menu-selected-icon"
                      : "sidebar-icon"
                  }
                />
              </ListItemIcon>
              <ListItemText primary="مدیریت دسترسی باکس ها" />
            </ListItem>
          ) : (
            ""
          )}
          {permission != null && permission.includes("REPORT_READ") ? (
            <ListItem
              className={
                history.location.pathname == "/reports" ? "menu-selected" : ""
              }
              button
              onClick={reportManagementPanel}
            >
              <ListItemIcon>
                <FormatListNumberedRtl
                  className={
                    history.location.pathname == "/reports"
                      ? "menu-selected-icon"
                      : "sidebar-icon"
                  }
                />
              </ListItemIcon>
              <ListItemText primary="گزارشات مالی" />
            </ListItem>
          ) : (
            ""
          )}
          {permission != null &&
          (permission.includes("REPORT_READ") ||
            permission.includes("CUSTOMER_WRITE")) ? (
            <ListItem
              className={
                history.location.pathname == "/all-reports"
                  ? "menu-selected"
                  : ""
              }
              button
              onClick={allReportManagementPanel}
            >
              <ListItemIcon>
                <FormatListNumberedRtl
                  className={
                    history.location.pathname == "/all-reports"
                      ? "menu-selected-icon"
                      : "sidebar-icon"
                  }
                />
              </ListItemIcon>
              <ListItemText primary="مدیریت گزارشات" />
            </ListItem>
          ) : (
            ""
          )}
          {permission != null && permission.includes("REPORT_READ") ? (
            <ListItem
              className={
                history.location.pathname == "/clmnt-reports"
                  ? "menu-selected"
                  : ""
              }
              button
              onClick={complementaryReportManagementPanel}
            >
              <ListItemIcon>
                <FormatListNumberedRtl
                  className={
                    history.location.pathname == "/clmnt-reports"
                      ? "menu-selected-icon"
                      : "sidebar-icon"
                  }
                />
              </ListItemIcon>
              <ListItemText primary="مدیریت گزارشات تکمیلی" />
            </ListItem>
          ) : (
            ""
          )}
          {permission != null && permission.includes("INVOICE_READ") ? (
            <ListItem
              className={
                history.location.pathname == "/invoices" ? "menu-selected" : ""
              }
              button
              onClick={invoiceManagementPanel}
            >
              <ListItemIcon>
                <Receipt
                  className={
                    history.location.pathname == "/invoices"
                      ? "menu-selected-icon"
                      : "sidebar-icon"
                  }
                />
              </ListItemIcon>
              <ListItemText primary="صورتحساب مالی" />
            </ListItem>
          ) : (
            ""
          )}
          <div className="small-only">
            <ListItem
              className={
                history.location.pathname == "/about-us" ? "menu-selected" : ""
              }
              button
              onClick={aboutUsPanel}
            >
              <ListItemIcon>
                <Info
                  className={
                    history.location.pathname == "/about-us"
                      ? "menu-selected-icon"
                      : "sidebar-icon"
                  }
                />
              </ListItemIcon>
              <ListItemText primary="درباره ما" />
            </ListItem>
          </div>
          <div className="small-only">
            <ListItem
              className={
                history.location.pathname == "/faq-content"
                  ? "menu-selected"
                  : ""
              }
              button
              onClick={faqContentPanel}
            >
              <ListItemIcon>
                <LiveHelp
                  className={
                    history.location.pathname == "/faq-content"
                      ? "menu-selected-icon"
                      : "sidebar-icon"
                  }
                />
              </ListItemIcon>
              <ListItemText primary="سوالات متداول" />
            </ListItem>
          </div>
          <ListItem button onClick={goChangePass}>
            <ListItemIcon>
              <ChangeHistoryIcon className="sidebar-icon" />
            </ListItemIcon>
            <ListItemText primary="تغییر رمز عبور" />
          </ListItem>
          <ListItem button onClick={doLogout}>
            <ListItemIcon>
              <ExitToAppIcon className="sidebar-icon" />
            </ListItemIcon>
            <ListItemText primary="خروج" />
          </ListItem>
        </List>
      </Drawer>
      <main className={[classes.content, "main-class"].join(" ")}>
        <div className={classes.toolbar} />

        {menuTab}

        {props.content}

        <Modal
          content={modalContent}
          ref={childRef}
          closePermission="true"
          closeModal={(event) => afterCloseModal(event)}
        />
      </main>
    </div>
  );
};
export default MiniDrawer;
